import { convertDateTimeToInputDateString } from "../../utils/datetimeUtils";
import handleAgentName from "../../utils/userUtils";

export default function GenericSalesForm({
    mode = "create",
    isSuperAdmin = false,
    agentGroup,
    agentName,
    coBrokeGroupOptions = [],
    coBrokeNameOptions = [],
    selectedCoBrokeGroupId,
    setSelectedCoBrokeGroupId,
    selectedCoBrokeAgentId,
    setSelectedCoBrokeAgentId,
    customerName,
    setCustomerName,
    customerEmail,
    setCustomerEmail,
    customerPhone,
    setCustomerPhone,
    customerAddress,
    setCustomerAddress,
    // Category props
    selectedCategory,
    setSelectedCategory,
    panelQty,
    setPanelQty,
    energy,
    setEnergy,
    // Product props
    // NEW: Payment Method props
    availablePaymentMethods = [],
    paymentMethod,
    setPaymentMethod,
    // Price props
    originalPrice,
    setOriginalPrice,
    canEditPrice = false,
    // NEW: Residential Match props
    residentialMatch,
    // Pricing props
    finalPrice,
    depositOn,
    setDepositOn,
    asternDiscount,
    setAsternDiscount,
    agentDiscount,
    setAgentDiscount,
    disableAgentFields = false,
    disableCustomerFields = false,
    disableProductFields = false,
    disablePricingFields = false,
    handleCoBrokeGroupChange,
}) {
    return (
        <>
            {/* Agent Information */}
            <fieldset className="createSalesForm-fieldset">
                <legend className="createSalesForm-legend">Agent Information</legend>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Agent Group:</label>
                                <input type="text" className="form-control" disabled value={agentGroup} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Agent Name:</label>
                                <input type="text" className="form-control" disabled value={agentName} />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Co-broke Group:</label>
                                <select className="form-select" value={selectedCoBrokeGroupId} onChange={handleCoBrokeGroupChange} disabled={disableAgentFields}>
                                    <option value=""></option>
                                    {coBrokeGroupOptions.map((option, index) => (
                                        <option key={index} value={option.groupId}>{option.groupName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Co-broke Agent Name:</label>
                                <select className="form-select" disabled={!selectedCoBrokeGroupId || disableAgentFields}
                                    value={selectedCoBrokeAgentId} onChange={e => setSelectedCoBrokeAgentId(e.target.value)}>
                                    <option value=""></option>
                                    {coBrokeNameOptions.map(option => (
                                        <option key={option.userId} value={option.userId}>{handleAgentName(option.firstName, option.lastName, option.alias)}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            {/* Customer Information */}
            <fieldset className="createSalesForm-fieldset">
                <legend className="createSalesForm-legend">Customer Information</legend>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="required-field">Customer Name:</label>
                                <input type="text" className="form-control" required
                                    value={customerName}
                                    onChange={e => setCustomerName(e.target.value)}
                                    disabled={disableCustomerFields && !isSuperAdmin}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="required-field">Phone Number:</label>
                                <input type="text" className="form-control" placeholder="0123456789" required
                                    value={customerPhone}
                                    onChange={e => setCustomerPhone(e.target.value)}
                                    disabled={disableCustomerFields && !isSuperAdmin}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Email:</label>
                                <input type="email" className="form-control"
                                    value={customerEmail}
                                    onChange={e => setCustomerEmail(e.target.value)}
                                    disabled={disableCustomerFields && !isSuperAdmin}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="required-field">Address:</label>
                                <textarea type="text" className="form-control" required
                                    value={customerAddress}
                                    onChange={e => setCustomerAddress(e.target.value)}
                                    disabled={disableCustomerFields && !isSuperAdmin}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            {/* Product Information */}
            <fieldset className="createSalesForm-fieldset">
                <legend className="createSalesForm-legend">Product Information</legend>
                <div className="container">
                    {/* Simple Category Toggle Buttons */}
                    <div className="row mb-3">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="required-field">Product Category:</label>
                                <div className="btn-group w-100" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${selectedCategory === "RESIDENTIAL" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => setSelectedCategory("RESIDENTIAL")}
                                        disabled={disableProductFields}
                                    >
                                        Residential
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${selectedCategory === "COMMERCIAL" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => setSelectedCategory("COMMERCIAL")}
                                        disabled={disableProductFields}
                                    >
                                        Commercial
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Panel Count and System Size */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="required-field">Number of Panels:</label>
                                <input
                                    type="number"
                                    min="1"
                                    step="1"
                                    className="form-control"
                                    value={panelQty}
                                    onChange={e => {
                                        const qty = parseInt(e.target.value) || 0;
                                        setPanelQty(qty);
                                        setEnergy(Number((qty * 0.62).toFixed(2)));
                                    }}
                                    disabled={disableProductFields}
                                    placeholder="Enter number of panels"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>System Size (kWp):</label>
                                <input
                                    type="text"
                                    className="form-control bg-light"
                                    value={energy || '0.00'}
                                    disabled
                                />
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.65rem' }}>Calculated: {panelQty} panels × 0.62 kWp</small>
                            </div>
                        </div>
                    </div>
                    {/* Residential Package Match Alert - Shows as ERROR when no match */}
                    {selectedCategory === 'RESIDENTIAL' && panelQty > 0 && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className={`alert d-flex align-items-start gap-2 mt-2 ${residentialMatch
                                    ? 'alert-success border-success'
                                    : 'alert-danger border-danger'
                                    }`} style={{ marginBottom: '0.45rem' }}>
                                    {residentialMatch
                                        ? (
                                            <>
                                                <span style={{ fontSize: '0.8em' }}>✨</span>
                                                <span style={{ fontSize: '0.8em' }}>
                                                    Matched Standard Package: <strong>{residentialMatch.inverterSize} kWac Inverter</strong> included.
                                                </span>
                                            </>
                                        )
                                        : (
                                            <>
                                                <span style={{ fontSize: '0.8em' }}>❌</span>
                                                <span style={{ fontSize: '0.8em' }}>
                                                    <strong>Error:</strong> No standard price found for {panelQty} panels. Please enter a valid panel count or switch to Commercial for custom pricing.
                                                </span>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Product Name - Only show for Commercial or when residential match found */}
                    {/* {(selectedCategory === 'COMMERCIAL' || (selectedCategory === 'RESIDENTIAL' && residentialMatch)) && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="required-field">Product Name:</label>
                                    <input
                                        type="text"
                                        className="form-control bg-light"
                                        value={selectedProductId ? productOptions.find(p => p.productId === selectedProductId)?.productName || '' : ''}
                                        disabled
                                    />
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.65rem' }}>
                                        {selectedCategory === 'RESIDENTIAL'
                                            ? 'Auto-selected based on panel count'
                                            : 'Select from available commercial products'}
                                    </small>
                                </div>
                            </div>
                        </div>
                    )} */}

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="required-field">Payment Method:</label>
                                <select
                                    className="form-select"
                                    required
                                    value={paymentMethod}
                                    onChange={e => setPaymentMethod(e.target.value)}
                                    disabled={disableProductFields || availablePaymentMethods.length === 0}
                                >
                                    <option value="">Select Payment Method</option>
                                    {availablePaymentMethods.map(method => (
                                        <option key={method.value} value={method.value}>
                                            {method.label}
                                        </option>
                                    ))}
                                </select>
                                {/* {availablePaymentMethods.length === 0 && panelCount > 0 && (
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.65rem' }}>
                                        {selectedCategory === 'RESIDENTIAL'
                                            ? 'Enter panel count to see payment options'
                                            : 'Select a product to see payment options'}
                                    </small>
                                )} */}
                            </div>
                        </div>
                    </div>

                    {/* Payment Method and Original Price */}
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="required-field">Original Price (RM):</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="form-control"
                                    disabled={!canEditPrice}
                                    value={originalPrice || ''}
                                    onChange={e => setOriginalPrice(parseFloat(e.target.value) || 0)}
                                    placeholder={canEditPrice ? "Enter price" : "Auto-populated"}
                                />
                                {/* <small className="text-muted d-block mt-1" style={{ fontSize: '0.65rem' }}>
                                    {selectedCategory === 'COMMERCIAL'
                                        ? 'Editable for commercial products'
                                        : 'Auto-populated for residential (disabled)'}
                                </small> */}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Astern Discount (RM):</label>
                                <input type="number" step="0.01" min="0" className="form-control"
                                    value={asternDiscount ?? ''}
                                    onWheel={e => e.target.blur()}
                                    onChange={e => setAsternDiscount(parseFloat(e.target.value) || 0)}
                                    disabled={disablePricingFields}
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Agent Discount (RM):</label>
                                <input type="number" step="0.01" min="0" className="form-control"
                                    value={agentDiscount ?? ''}
                                    onWheel={e => e.target.blur()}
                                    onChange={e => setAgentDiscount(parseFloat(e.target.value) || 0)}
                                    disabled={disablePricingFields}
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        {/* <div className="col-md-6">
                            <div className="form-group">
                                <label>Final Price (RM):</label>
                                <input type="number" min={0} className="form-control bg-light" disabled value={netPrice ?? finalPrice ?? 0.00} />
                            </div>
                        </div> */}
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Deposit Payment Date:</label>
                                <input type="date" className="form-control"
                                    value={convertDateTimeToInputDateString(depositOn)}
                                    onChange={e => setDepositOn(e.target.value)}
                                    disabled={disablePricingFields}
                                />
                            </div>
                        </div>
                    </div>
                    <hr className="my-3" />
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fs-5 fw-bold">Final Price</span>
                        <span className="fs-4 fw-bold text-primary">RM {(finalPrice || 0).toLocaleString()}</span>
                    </div>
                    <div className="text-end">
                        <small className="text-muted">Formula: Original Price - Astern Discount - Agent Discount</small>
                    </div>
                </div>
            </fieldset>

            {/* below to be removed */}
            {/* Payment & Pricing Information */}
            {/* <fieldset className="createSalesForm-fieldset">
                <legend className="createSalesForm-legend">Payment & Pricing Information</legend>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="required-field">Payment Method:</label>
                                <select
                                    className="form-select"
                                    required
                                    value={paymentMethod}
                                    onChange={e => setPaymentMethod(e.target.value)}
                                    disabled={disableProductFields || availablePaymentMethods.length === 0}
                                >
                                    <option value="">Select Payment Method</option>
                                    {availablePaymentMethods.map(method => (
                                        <option key={method.value} value={method.value}>
                                            {method.label}
                                        </option>
                                    ))}
                                </select>
                                {availablePaymentMethods.length === 0 && panelCount > 0 && (
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.65rem' }}>
                                        {selectedCategory === 'RESIDENTIAL'
                                            ? 'Enter panel count to see payment options'
                                            : 'Select a product to see payment options'}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Astern Discount (RM):</label>
                                <input type="number" step="0.01" min="0" className="form-control"
                                    value={asternDiscount ?? ''}
                                    onWheel={e => e.target.blur()}
                                    onChange={e => setAsternDiscount(parseFloat(e.target.value) || 0)}
                                    disabled={disablePricingFields}
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Agent Discount (RM):</label>
                                <input type="number" step="0.01" min="0" className="form-control"
                                    value={agentDiscount ?? ''}
                                    onWheel={e => e.target.blur()}
                                    onChange={e => setAgentDiscount(parseFloat(e.target.value) || 0)}
                                    disabled={disablePricingFields}
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Final Price (RM):</label>
                                <input type="number" min={0} className="form-control bg-light" disabled value={netPrice ?? finalPrice ?? 0.00} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Deposit Payment Date:</label>
                                <input type="date" className="form-control"
                                    value={convertDateTimeToInputDateString(depositOn)}
                                    onChange={e => setDepositOn(e.target.value)}
                                    disabled={disablePricingFields}
                                />
                            </div>
                        </div>
                    </div>
                    <hr className="my-3" />
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fs-5 fw-bold">Final Price</span>
                        <span className="fs-4 fw-bold text-primary">RM {(netPrice || 0).toLocaleString()}</span>
                    </div>
                    <div className="text-end">
                        <small className="text-muted">Formula: Original Price - Astern Discount - Agent Discount</small>
                    </div>
                </div>
            </fieldset> */}
        </>
    );
}